module.exports = require("@telia-company/tv.web-playback-sdk");